import { DetailsSection } from '../../../VideoEventDetails/DetailsSection';
import { Grid } from '../../../../../MaterialUIComponents';
import { React } from '../../../../../Imports';
import { VideoEventResponse } from '$Generated/api';
import { VideoRecallDetailsSection } from './VideoRecallDetailsSection';
import { VideoEventPrevNextSection } from '$Components/VideoEvents/VideoEventDetails/VideoEventPrevNextSection';

const styles = require('./VideoRecallSidePanel.scss') as {
    cardContent: string;
    responsiveGrid: string;
};

interface IRecallSidePanelBaseProps {
    event: VideoEventResponse;
    eventStatus: string | undefined;
    width: any;
    onSelectVideoEvent: (eventId: string, goBack: boolean) => void;
    deleteVideoRecall: (eventId: number) => void;
    promoteVideoRecall: (eventId: number) => void;
    getFullListOfSucessRecallIds: () => void;
}
type IRecallSidePanelProps = IRecallSidePanelBaseProps;

const _VideoRecallSidePanel: React.FC<IRecallSidePanelProps> = ({
    event,
    eventStatus,
    width,
    onSelectVideoEvent,
    deleteVideoRecall,
    promoteVideoRecall,
    getFullListOfSucessRecallIds,
}) => {
    return (
        <div className={styles.cardContent}>
            <VideoEventPrevNextSection eventId={event.displayId} onSelectVideoEvent={onSelectVideoEvent} isRecall={true} />

            <DetailsSection width={width}>
                <Grid key={`details-section-video-recall-details-section`} className={styles.responsiveGrid} item sm={12} md={6} lg={12}>
                    <VideoRecallDetailsSection
                        event={event}
                        eventStatus={eventStatus}
                        deleteVideoRecall={deleteVideoRecall}
                        promoteVideoRecall={promoteVideoRecall}
                        onSelectVideoEvent={onSelectVideoEvent}
                        getFullListOfSucessRecallIds={getFullListOfSucessRecallIds}
                    />
                </Grid>
            </DetailsSection>
        </div>
    );
};

export const VideoRecallSidePanel = _VideoRecallSidePanel;
